import { FiSun, FiMoon } from "react-icons/fi";
import { useTheme } from '../../context/ThemeContext';
import styles from './ThemeToggle.module.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button className={styles.toggleBtn} onClick={toggleTheme} aria-label="Toggle theme">
      <span className={styles.icon}>
        {theme === 'dark' ? <FiSun /> : <FiMoon />}
      </span>
    </button>
  );
};

export default ThemeToggle;